<script>
    import TheSvgIcon from "@main/packages/TheSvgIcon";

    export default {
        name: "LookbookTooltip",
        components: {
            TheSvgIcon,
        },
        props: {
            product: Object,
            offerId: String,
        },
        computed: {
            name() {
                return this.product.shortName || this.product.name;
            },
        },
    };
</script>

<template>
    <div class="lookbook-tooltip">
        <div class="lookbook-tooltip__text">
            <button class="lookbook-tooltip__close desktop-hidden" @click="$emit('on-close')">
                <the-svg-icon class="" name="close" :size-w="16"></the-svg-icon>
            </button>
            <div class="lookbook-tooltip__title">{{ name }}</div>
            <div class="lookbook-tooltip__price-wrapper">
                <div
                    class="lookbook-tooltip__price"
                    :class="{ 'is-sale': product.discountPercent }"
                >
                    {{ product.discountPrice | formatPrice }}&nbsp;₽
                </div>
                <template v-if="product.discountPercent">
                    <div class="lookbook-tooltip__price-old">
                        {{ product.price | formatPrice }}&nbsp;₽
                    </div>
                    <div class="lookbook-tooltip__label">-{{ product.discountPercent }}%</div>
                </template>
            </div>
        </div>
        <div class="lookbook-tooltip__footer">
            <router-link
                :to="{ name: 'Product', params: { slug: product.slug, offer: offerId } }"
                target="_blank"
                class="lookbook-tooltip__link"
            >
                <span>Подробнее</span>
                <img src="/static/xd-design/icons/double-arrow.svg" alt="" />
            </router-link>
        </div>
    </div>
</template>

<style lang="scss">
    .lookbook-tooltip {
        background-color: #fff;
    }

    .lookbook-tooltip__text {
        position: relative;
        padding: 20px;
        border: solid #000;
        border-width: 1px 1px 0 1px;
    }

    .lookbook-tooltip__close {
        position: absolute;
        top: 16px;
        right: 16px;
        @include box(16px);
        svg {
            filter: brightness(0);
        }
    }

    .lookbook-tooltip__title {
        margin-bottom: 4px;
        color: #000;
        font-size: 18px;
        font-weight: 900;
        line-height: 21px;
        text-transform: uppercase;
        @include bp($bp-desktop-sm) {
            margin-bottom: 8px;
            font-size: 22px;
            line-height: 26px;
        }
    }

    .lookbook-tooltip__price-wrapper {
        display: flex;
        align-items: center;
    }

    .lookbook-tooltip__price {
        color: #000;
        font-size: 18px;
        font-weight: 500;
        line-height: 21px;
        &.is-sale {
            color: #f50067;
        }
        @include bp($bp-desktop-sm) {
            font-size: 20px;
            line-height: 23px;
        }
    }

    .lookbook-tooltip__price-old {
        margin-left: 8px;
        color: #637381;
        font-size: 12px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: -0.02em;
        text-decoration: line-through;
        @include bp($bp-desktop-sm) {
            font-size: 14px;
        }
    }

    .lookbook-tooltip__label {
        margin-left: 10px;
        padding: 0 4px;
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        line-height: 16px;
        background-color: #f50067;
        @include bp($bp-desktop-sm) {
            font-size: 14px;
            line-height: 20px;
        }
    }

    .lookbook-tooltip__link {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 50px;
        color: #fff;
        font-weight: 500;
        font-size: 14px;
        line-height: 50px;
        text-align: center;
        text-transform: uppercase;
        background: #000;
        cursor: pointer;
        span {
            margin-left: 10px;
            transition: transform 0.2s ease-in;
        }
        img {
            transform: translateX(5px);
        }
        @include bp($bp-desktop-lg) {
            font-size: 16px;
            img {
                opacity: 0;
                transform: translateX(5px);
                transition: opacity 0.2s ease-in, transform 0.2s ease-in;
            }
        }

        &:hover {
            span {
                transform: translateX(-10px);
            }
            img {
                opacity: 1;
                transform: translateX(-5px);
            }
        }
    }
</style>
